function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m418.635 119.367c-36.288-36.287-82.568-58.943-132.634-65.425v-23.942c0-16.542-13.458-30-30-30s-30 13.458-30 30v23.953c-34.188 4.464-66.902 16.539-95.942 35.583-4.618 3.028-5.907 9.228-2.878 13.846 3.028 4.618 9.227 5.906 13.846 2.878 28.793-18.882 61.547-30.263 95.691-33.381.16-.011.32-.023.478-.042 6.228-.554 12.501-.837 18.805-.837 115.794 0 210 94.206 210 210s-94.206 210-210 210-210-94.206-210-210c0-41.035 11.848-80.794 34.264-114.981 3.028-4.619 1.739-10.818-2.879-13.846-4.619-3.027-10.817-1.739-13.846 2.879-24.558 37.454-37.538 81.006-37.538 125.948 0 61.435 23.924 119.193 67.365 162.635 43.441 43.441 101.199 67.365 162.634 67.365s119.193-23.924 162.634-67.365c43.442-43.441 67.366-101.2 67.366-162.635s-23.924-119.191-67.366-162.633zm-172.635-67.141v-22.226c0-5.514 4.486-10 10-10s10 4.486 10 10v22.228c-3.322-.141-6.655-.226-10-.226-3.342 0-6.675.081-10 .224z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m256 472.002c104.767 0 190-85.233 190-190s-85.233-190-190-190c-104.766 0-190 85.234-190 190s85.234 190 190 190zm0-360.001c93.739 0 170 76.262 170 170s-76.262 170-170 170-170-76.262-170-170c.001-93.738 76.263-170 170-170z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m137.559 292.002h83.691l8.734 13.197c.741 1.12 1.7 2.079 2.82 2.82l13.197 8.735v83.691c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10v-70.455l71.362 47.232c1.687 1.116 3.606 1.661 5.517 1.661 2.581 0 5.142-.997 7.074-2.929 3.361-3.362 3.892-8.626 1.268-12.59l-47.232-71.362h70.455c5.522 0 10-4.477 10-10s-4.478-10-10-10h-83.692l-8.734-13.197c-.741-1.12-1.7-2.079-2.819-2.82l-13.197-8.735v-83.691c0-5.523-4.478-10-10-10-5.523 0-10 4.477-10 10v70.454l-71.362-47.232c-3.965-2.624-9.229-2.094-12.591 1.268s-3.892 8.626-1.268 12.59l47.232 71.363h-70.454c-5.523 0-10 4.477-10 10s4.476 10 9.999 10zm128.904-20.462 40.955 61.879-61.879-40.955-40.955-61.879z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m100.44 136.438c2.4 0 4.808-.859 6.724-2.601l.005-.005c4.086-3.715 4.385-10.037.67-14.124-3.713-4.086-10.042-4.386-14.128-.67-4.086 3.715-4.388 10.04-.673 14.126 1.974 2.172 4.683 3.274 7.402 3.274z"
});

var SvgExplore = function SvgExplore(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512.002 512.002",
    height: 512,
    viewBox: "0 0 512.002 512.002",
    width: 512,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExplore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/explore.902c4365.svg";
export { ForwardRef as ReactComponent };